import React from "react";
import styled from "styled-components";

interface CompanySectionCardProps
{
    // Ancla de la sección (índice lateral del paso 3)
    id?: string;
    number: number;
    title: string;
    description?: string;
    children?: React.ReactNode;
}

// Tarjeta numerada de sección de las pantallas del alta de empresa
const CompanySectionCard: React.FC<CompanySectionCardProps> = ({ id, number, title, description, children }) =>
{
    return(
        <Card id={id}>
            <SectionHeader>
                <SectionNumber>{number}</SectionNumber>
                <div>
                    <h3>{title}</h3>
                    {description && <p>{description}</p>}
                </div>
            </SectionHeader>
            {children}
        </Card>
    );
};

export default CompanySectionCard;

const Card = styled.section`
    background: ${(props) => props.theme?.palette?.tertiary || "#F3F6F8"};
    border-radius: 24px;
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    /* Que al saltar desde el índice lateral no quede pegada al borde superior */
    scroll-margin-top: 24px;

    @media screen and (max-width: 599px)
    {
        padding: 20px 16px;
    }
`;

const SectionHeader = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 16px;
    cursor: default;

    h3
    {
        margin: 0;
        font-size: 22px;
        font-weight: 700;
        color: #2a4143;
    }

    p
    {
        margin: 4px 0 0;
        font-size: 15px;
        color: #5f7172;
    }
`;

const SectionNumber = styled.span`
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: ${(props) => props.theme?.palette?.themePrimary || "#CC214F"};
    color: #ffffff;
    font-weight: 700;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
